import React from 'react';
import { AuthRoles } from "components/auth";

export const ExpensesReceiptConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/expenses_receipt`,
            component: React.lazy(() => import('./ExpensesReceipt'))
        }
    ]
};